exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-downloads-tsx": () => import("./../../../src/pages/downloads.tsx" /* webpackChunkName: "component---src-pages-downloads-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-our-company-tsx": () => import("./../../../src/pages/ourCompany.tsx" /* webpackChunkName: "component---src-pages-our-company-tsx" */),
  "component---src-pages-proyectos-tsx": () => import("./../../../src/pages/proyectos.tsx" /* webpackChunkName: "component---src-pages-proyectos-tsx" */)
}

